import ProviderBoard from "./providers/ProviderBoard";
import RcChainAnalysis from "./providers/RcChainAnalysis";
import SpendTrend from "./providers/SpendTrend";

/**
 * Dashboard → Reports (CEO only): every paid data vendor on one board —
 * their APIs, who answers first, usage, outstanding balances — plus what the RC
 * chain delivered for the money, and what RC and challan lookups cost, so the
 * recharge size picks itself.
 *
 * The parked-plate list was removed in Oct 2026: every plate in it was a typo,
 * a chassis number or a test entry, so there was nothing to act on. The
 * suppression itself stays (it is what stops one dud plate being re-billed on
 * every retry) and `?force_refresh=true` still bypasses it when a real car is
 * caught, as does `POST /providers/rc-suppressions/{plate}/clear`.
 */
export default function VehicleDataReports() {
  return (
    <div className="space-y-5" data-testid="dashboard-reports">
      <div>
        <h2 className="text-lg font-semibold text-slate-800">Reports — data vendors</h2>
        <p className="text-sm text-slate-500">
          Who answers first, what each call costs, and what is left in every prepaid wallet.
        </p>
      </div>
      <ProviderBoard />
      <RcChainAnalysis />
      <SpendTrend />
    </div>
  );
}
